import { render, staticRenderFns } from "./POC.vue?vue&type=template&id=0b238da2&scoped=true&"
import script from "./POC.vue?vue&type=script&setup=true&lang=js&"
export * from "./POC.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b238da2",
  null
  
)

export default component.exports